// vendors
import {
  useMantineTheme,
  Card,
  Grid,
  UnstyledButton,
  Box,
  Text,
  Modal,
} from '@mantine/core';

import fieldData from './fieldsData';
import 'jquery-ui-dist/jquery-ui';

export default function AddFieldModal(props) {
  const theme = useMantineTheme();

  return (
    <Modal
      title='Select Field Type'
      centered
      opened={props.opened}
      onClose={() => props.onClose()}
    >
      <Grid sx={{ flexDirection: 'column' }}>
        {fieldData.map((field, i) => (
          <Grid.Col key={i}>
            <UnstyledButton
              sx={{ width: '100%' }}
              onClick={() => {
                typeof props.onFieldClick === typeof function () {} &&
                  props.onFieldClick(field);
              }}
              disabled={field.disabled === true ? true : false}
            >
              <Card
                withBorder
                sx={{
                  '&:hover': {
                    backgroundColor:
                      theme.colorScheme === 'light'
                        ? theme.colors.gray[0]
                        : theme.colors.dark[5],
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Box>{field.icon}</Box>
                  <Text size={'sm'} mx={10}>
                    {field.label}
                  </Text>
                </Box>
              </Card>
            </UnstyledButton>
          </Grid.Col>
        ))}
      </Grid>
    </Modal>
  );
}
